export function shouldShowIncidentQuestion({
  isRow3Complete,
  isRow4Complete,
  isRow4PauseComplete,
  isRow7A3RecommendationComplete,
  isQuestionFiveComplete,
  isRow6Complete,
  isRow7Complete,
  isSrhtBasicCourseWorkflow,
}) {
  const isWorkflowPrerequisiteComplete = !isSrhtBasicCourseWorkflow || Boolean(isRow3Complete);

  return Boolean(
    isWorkflowPrerequisiteComplete
      && isRow4Complete
      && isRow4PauseComplete
      && isRow7A3RecommendationComplete
      && isQuestionFiveComplete
      && isRow6Complete
      && isRow7Complete,
  );
}

export function getIncidentQuestionNumber(copyQuestionNumber, shouldShowCopyQuestion) {
  return Number(copyQuestionNumber) + Number(Boolean(shouldShowCopyQuestion));
}

export function getPdfQuestionNumber(incidentQuestionNumber, shouldShowIncident) {
  return Number(incidentQuestionNumber) + Number(Boolean(shouldShowIncident));
}
